import { Bar, mixins } from 'vue-chartjs'
import Chart from 'chart.js'
import colors from '@/utils/colors'
const { reactiveProp } = mixins

export const BarChart = {
  extends: Bar,
  mixins: [reactiveProp],
  data() {
    return {
      colors: colors.cores,
      colorHex: colors.coresHexa
    }
  },
  props: {
    options: {
      type: Object
    },
    gradiente: {
      type: Boolean,
      default: true
    }
  },
  mounted() {
    if (this.$refs.canvas) {
      Chart.plugins.register({
        id: 'paddingBelowLegends',
        beforeInit: function(chart, options) {
          chart.legend.afterFit = function() {
            this.height = this.height + 15
          }
        }
      })

      Chart.Tooltip.positioners.middle = items => {
        if (items.length !== 1) {
          // For more than 1 item, just show at the nearest
          return Chart.Tooltip.positioners.average(items)
        }

        const el = items[0]._view
        let xPos = 0
        let yPos = 0

        if (el) {
          const { base, horizontal, x, y } = el
          if (horizontal) {
            xPos = (base + x) / 2
            yPos = y
          } else {
            xPos = x
            yPos = (base + y) / 2
          }
        }

        return {
          x: xPos,
          y: yPos
        }
      }

      // if (this.chartData.datasets[0])
      //   this.chartData.datasets[0].backgroundColor = this.montarCor(
      //     this.colors[0]
      //   )

      this.renderChart(this.chartData, this.options)
      this.htmlLegend = this.generateLegend()
    }
  },
  methods: {
    montarCor(cor) {
      if (this.gradiente) {
        return this.gradient(cor)
      } else {
        return 'rgba(' + cor + ',1)'
      }
    },
    gradient(color) {
      var gradient = this.$refs.canvas
        .getContext('2d')
        .createLinearGradient(0, 0, 0, 450)

      gradient.addColorStop(0, 'rgba(' + color + ', 1)')
      gradient.addColorStop(0.5, 'rgba(' + color + ', 0.6)')
      gradient.addColorStop(1, 'rgba(' + color + ', 0.2)')

      return gradient
    }
  },
  watch: {
    chartData() {
      // for (
      //   let index = 0;
      //   index < this.$data._chart.data.datasets.length;
      //   index++
      // ) {
      //   this.$data._chart.data.datasets[index].backgroundColor = this.montarCor(
      //     this.colors[index]
      //   )
      // }
      // // necessário atualizar 2x para corrigir problemas nas cores das labels
      // this.$data._chart.update()
      // this.$data._chart.update()
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/common/BarChart.js